import { createReducer, on } from '@ngrx/store';
import { CartonContents } from '@app/store/sorting/models';
import { placedBoxesActions } from '../actions/placed-boxes.actions';
import { Box } from '../models';

export interface PlacedBoxesState {
    boxes: Box[];
    page: number;
    hasMore: boolean;
    contents: CartonContents | null;
    lockedCode: string | null;
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
}

export const initialState: PlacedBoxesState = {
    boxes: [],
    page: 0,
    hasMore: false,
    contents: null,
    lockedCode: null,
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
};

export const placedBoxesReducer = createReducer(
    initialState,
    // Load
    on(placedBoxesActions.loadBoxes, (state): PlacedBoxesState => ({
        ...state,
        loading: true,
        loaded: null,
    })),
    on(placedBoxesActions.loadBoxesSuccess, (state, { payload, page, hasMore }): PlacedBoxesState => ({
        ...state,
        loading: false,
        loaded: true,
        page,
        hasMore,
        boxes: page === 1 ? payload : [...state.boxes, ...payload.filter((box) => !state.boxes.some((item) => item.id === box.id))],
    })),
    on(placedBoxesActions.loadBoxesError, (state): PlacedBoxesState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    // Lock / unlock
    on(placedBoxesActions.lockBox, (state): PlacedBoxesState => ({
        ...state,
        contents: null,
    })),
    on(placedBoxesActions.lockBoxSuccess, (state, { payload }): PlacedBoxesState => ({
        ...state,
        contents: payload,
        lockedCode: payload.code,
    })),
    on(placedBoxesActions.unlockBoxSuccess, placedBoxesActions.unlockBoxError, (state, { cartonCode }): PlacedBoxesState => ({
        ...state,
        lockedCode: state.lockedCode === cartonCode ? null : state.lockedCode,
    })),
    // Reduce / increase item
    on(placedBoxesActions.reduceItem, placedBoxesActions.increaseItem, (state): PlacedBoxesState => ({
        ...state,
        saving: true,
    })),
    on(placedBoxesActions.reduceItemSuccess, placedBoxesActions.increaseItemSuccess, (state, { payload }): PlacedBoxesState => ({
        ...state,
        saving: false,
        contents: payload,
    })),
    on(placedBoxesActions.reduceItemError, placedBoxesActions.increaseItemError, (state): PlacedBoxesState => ({
        ...state,
        saving: false,
    })),
    // Close
    on(placedBoxesActions.closeBox, (state): PlacedBoxesState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(placedBoxesActions.closeBoxSuccess, (state, { code }): PlacedBoxesState => ({
        ...state,
        saving: false,
        saved: true,
        lockedCode: null,
        boxes: state.boxes.filter((box) => box.code !== code),
    })),
    on(placedBoxesActions.closeBoxError, (state): PlacedBoxesState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Clear
    on(placedBoxesActions.clear, (): PlacedBoxesState => ({ ...initialState })),
);
